import { ArticleAttributeAssignment } from './ArticleAttributeAssignment';
import { Interest } from './Interest';
import { Question } from './Question';

export enum ArticleStatus {
  DRAFT = 'draft',
  ACTIVE = 'active',
  DELETED = 'deleted',
}

export interface Article {
  id: string;
  title: string;
  status: ArticleStatus;
  slug: string;
  coverImage?: {
    originalUrl: string;
    compressedUrl: string | null;
    thumbnailUrl: string | null;
    coverUrl: string | null;
  } | null;
  coverVideo?: {
    url: string;
  } | null;
  contentVideo?: {
    url: string;
  } | null;
  wordCount: number;
  description: string;
  passage: string;
  lexileLevel: string;
  isFiction: boolean;
  grade: number;
  questions?: Question[];
  attributeAssignments?: ArticleAttributeAssignment[];
  createdByUserId?: string;
  interests?: Interest[];
  createdAt: Date;
  updatedAt: Date;
  generatedAt?: Date;
  challengingWordsGeneratedAt?: Date;
  quizGeneratedAt?: Date;
  deletedAt?: Date;
  coverImageTriggeredAt?: Date;
  coverImageGeneratedAt?: Date;
  coverVideoTriggeredAt?: Date;
  coverVideoGeneratedAt?: Date;
  contentVideoTriggeredAt?: Date;
  contentVideoGeneratedAt?: Date;
  isLibraryArticle?: boolean;
  type?: 'article' | 'chapter';
  likes?: number;
}
